import React from "react";
import Hidden from "@material-ui/core/Hidden";
import PrimaryNavigator from "containers/appNavigator";
import PrimaryBar from "components/primaryBar";
import Avatar from "containers/avatar";
import NavigationButton from "containers/navigationButton";
import { useStyles, drawerWidth } from "./styles";

export default function({ children }) {
  const classes = useStyles();

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <div className={classes.root}>
      <nav className={classes.drawer}>
        <Hidden smUp implementation="js">
          <PrimaryNavigator
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
          />
        </Hidden>
        <Hidden xsDown implementation="css">
          <PrimaryNavigator PaperProps={{ style: { width: drawerWidth } }} />
        </Hidden>
      </nav>
      <div className={classes.app}>
        <PrimaryBar
          avatar={<Avatar />}
          navigationButton={
            <NavigationButton onMenuButtonClick={handleDrawerToggle} />
          }
        />
        {children}
      </div>
    </div>
  );
}
